// Валидация формы
import {postDataForm} from "./utils";

window.formValidate = function () {
    let form = $('.js-form');

    form.each(function () {
        let thisForm = $(this);
        let url = thisForm.attr('action');
        let callBackName = thisForm.attr('data-callback');
        let abpServiceName = thisForm.attr('data-service');

        thisForm.validate({
            focusInvalid: false,
            rules: {
                email: {
                    checkEmailFormat: true
                },
                phone: {
                    checkPhoneFormat: true
                }
            },
            messages: {
                email: {
                    checkEmailFormat: "Неверный формат email"
                },
                phone: {
                    checkPhoneFormat: "Неверный номер"
                }
            },
            ignore: ':not(:visible)',
            highlight: function (element) {
                $(element).closest(".form-field").addClass('form-field--error');
            },
            unhighlight: function (element) {
                $(element).closest(".form-field").removeClass('form-field--error');
            },
            submitHandler: function (form, event) {
                event.preventDefault();
                let formParams = thisForm.serializeArray();

                $.each(thisForm.find('.js-input-file'), function (i, tag) {
                    $.each($(tag)[0].files, function (i, file) {
                        if (file !== undefined) {
                            formParams[formParams.length] = {name: tag.name, value: file};
                            formParams[formParams.length + 1] = {name: 'fileName', value: file.name};
                        }
                    });
                });
                
                let formData = {};
                $.each(formParams, function (i, field) {
                    let arr = []
                    if (field !== undefined && typeof field.value !== "object" && field.value.trim() !== "") {
                        if (formData[field.name] !== undefined) {
                            let val = formData[field.name];
                            if (!Array.isArray(val)) {
                                arr = [val];
                            }
                            arr.push(field.value.trim());
                            formData[field.name] = arr;
                        } else {
                            formData[field.name] = field.value;
                        }
                    }
                });

                if (abpServiceName !== undefined) {
                    let button = thisForm.find('button');
                    let lastButtonText = button.text(); 
                    button.prop('disabled', true);
                    button.text('Подождите...');
                    
                    if(abpServiceName === "CallbackForm"){
                        postDataForm("/callback/submit", formData).then(function (result) {
                            // window.location = `/order/thankyou/?id=${result.guidId}`;
                            $('.popup').removeClass('is-show');
                            removeBlur();
                        });
                    } else {
                        postDataForm("/cart/submit", formData).then(function (result) {
                            if(result !== null) {
                                const resp = JSON.parse(result);
                                window.location = `/order/thankyou/?id=${resp.guidId}`;    
                            }
                        });
                    }
                    
                   /* postDataForm("/cart/submit", formData).then(function (result) {
                        window.location = `/order/thankyou/?id=${result.guidId}`;
                    });*/
                    
                    /*abp.services.app.jsProxy.postForm(abpServiceName, formData).done(function (result) {
                        switch (abpServiceName) {
                            case 'CartSubmit':
                                // window.shop.ymBuy(result.numberId, result.currency, result.items);
                                window.location = `/order/thankyou/?id=${result.guidId}`;
                                break;
                            case 'CallbackForm':
                                // window.shop.ymCallback();
                                break;
                            case 'CommercialOfferForm':
                                // window.shop.ymOffer();
                                break;
                        }
                        button.prop('disabled', false);
                        button.text(lastButtonText);
                        if (result !== false) {
                            if (callBackName) {
                                SB[callBackName]();
                            }
                            let idThank = thisForm.data('thank');
                            $(idThank).addClass('is-show');
                            thisForm[0].reset();
                        }
                    });*/
                }
               
                // if (typeof thisForm.data('thank') !== 'undefined') {
                //     let idThank = thisForm.data('thank');
                //     $(idThank).addClass('is-show');
                // }
                //
                // thisForm[0].reset();
                //
                // let $select2 = $('.js-select');
                // if ($select2.length) {
                //     $select2.each(function () {
                //         $(this).val('').trigger('change');
                //     })
                // }
                //окно благодарности
                return false;
            }
        });

    });

    // Ввод только цифр
    $('.js-number, .js-counter-input').on('keypress', function (e) {
        let charCode = (e.which) ? e.which : e.keyCode;
        if (charCode > 31 && (charCode < 48 || charCode > 57)) {
            return false;
        }
    });

    // Деактивация кнопки отправки формы при снятии галочки с чекбокса согласия
    $('body').on('change', '.js-agree', function () {
        let $this = $(this);
        let btn = $this.closest('form').find('button[type="submit"]');
        if ($this.is(':checked')) {
            btn.prop('disabled', false);
        } else {
            btn.prop('disabled', true);
        }
    });

    // add custom email format checker method
    jQuery.validator.addMethod("checkEmailFormat", function (value, element) {
        let m = value.match(/^[a-zA-Z0-9_\.%\+\-]+@[a-zA-Z0-9\.\-]+\.[a-zA-Z]{2,}$/);
        return m;
    });

    jQuery.validator.addMethod("checkPhoneFormat", function (value, element) {
        let m = value.match(/^[0-9\+\-\(\)]+$/);
        return m;
    });

    $B.on('click', 'label.error', function () {
        $(this).hide().siblings('input,textarea').focus();

    });

    $B.on('keyup', 'input', function () {
        $(this).siblings('label.error').hide();
    });

    $B.on('change', '.js-select', function () {
        $(this).closest('.form-field').removeClass('form-field--error');
    })

    $('.popup-thank').on('click', function () {
        $(this).removeClass('is-show');
    });

    $('.js-input-questions').change(function () {
        $('.callback-popup__form textarea').text($(this).val());
    });
};

formValidate();



